import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchSingleTemplateSuccess,
  fetchSingleTemplateFailure,
} from 'redux/template/actions';
import request from 'utils/request';
import urls from 'utils/config';
import TemplatesActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { TEMPLATE_BASE_URL } = urls || {};

export function* fetchSingleTemplate({ payload }) {
  const { id, cb } = payload;
  const url = `${TEMPLATE_BASE_URL}/templates/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchSingleTemplateSuccess(response.raw));
    cb(response.raw);
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Create Template: ${response.message}`);
    yield put(fetchSingleTemplateFailure(response.message));
  }
}

export function* onFetchSingleTemplate() {
  yield takeEvery(
    TemplatesActionTypes.FETCH_SINGLE_TEMPLATE,
    fetchSingleTemplate
  );
}
